/**
 * HubSpot internal name of the hidden field carrying the event a submission
 * came from. It is a numeric HubSpot property, so only the marketing event's
 * record ID may be sent, never the event name.
 */
export const HUBSPOT_MARKETING_EVENT_FIELD = "last_marketing_event_record_id";


export const NEWSLETTER_FORM_KEY = "c24bf3c1-5691-44e2-9e97-da697891aa96";
export const DEMO_FORM_KEY = "47068428-49de-47f3-86b3-dd399673f083";
export const COMPETITOR_DEMO_FORM_KEY = "a186946b-a99f-45e2-ae18-83a71f4fe28f";
